import React from "react";
import { InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import UnitFormPresenter from "./UnitFormPresenter";

class UnitFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      office: [],
      division: [],
      section: [],
      region: [],
      selectedRegion: { name: "" },
      selectedOffice: { name: "" },
      officeName: { name: "" },
      selectedDivision: { name: "" },
      selectedSection: { name: "" },
    };
    this.presenter = new UnitFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "Units";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const allRegion = await findObjectUseCase().execute("Region");
    const region = allRegion.filter((data) => data.status === "active");
    this.setState({ region });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      this.loadRegion();
    }
  }
  async loadRegion() {
    const { object } = this.state;
    if (object.name) {
      const query = {
        where: {
          status: "active",
        },
      };
      const region = await findObjectUseCase().execute("Region", query);
      const selected = region.find((item) => item.id === object.region);
      this.setState({
        region,
        selectedRegion: { id: selected?.id, name: selected?.name },
      });
      this.loadOfficeData(object, query);
    }
  }

  async loadOfficeData(object, query) {
    const officeQuery = {
      where: {
        ...query.where,
        region: object.region,
      },
    };
    if (object.region) {
      const office = await findObjectUseCase().execute("offices", officeQuery);
      const selected = office.find((item) => item.id === object.office);
      this.setState({
        office,
        selectedOffice: { name: selected?.name, id: selected?.id },
      });
      this.loadDivisionData(object, query);
    }
  }

  async loadDivisionData(object, query) {
    const divisionQuery = {
      where: {
        ...query.where,
        office: object.office,
      },
    };
    if (object.office) {
      const division = await findObjectUseCase().execute(
        "Division",
        divisionQuery
      );
      const selected = division.find((item) => item.id === object.division);
      this.setState({
        division,
        selectedDivision: { name: selected?.name, id: selected?.id },
      });
    }
    this.loadSectionData(object, query);
  }

  async loadSectionData(object, query) {
    if (object.section) {
      const sectionQuery = {
        where: {
          ...query.where,
          division: object.division,
        },
      };
      const section = await findObjectUseCase().execute(
        "Sections",
        sectionQuery
      );
      const selected = section.find((item) => item.id === object.section);
      this.setState({
        section,
        selectedSection: { name: selected.name, id: selected.id },
      });
    }
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleRegionChange = async (selectedRegion) => {
    this.setState({ selectedRegion });
    this.presenter.onChange();
    if (selectedRegion === "") {
      this.setState({
        office: [],
        division: [],
        section: [],
        selectedOffice: "",
        selectedDivision: "",
        selectedSection: "",
      });
    }
    if (selectedRegion) {
      const query = {
        where: {
          status: "active",
          region: selectedRegion.id,
        },
      };
      const office = await findObjectUseCase().execute("offices", query);
      this.setState({ office, selectedOffice: "" });
    }
  };

  handleOfficeChange = async (selectedOffice) => {
    this.setState({ selectedOffice });
    if (selectedOffice === "") {
      this.setState({
        division: [],
        section: [],
        selectedDivision: "",
        selectedSection: "",
      });
    }
    if (selectedOffice) {
      const query = {
        where: {
          status: "active",
          office: selectedOffice.id,
        },
      };
      const division = await findObjectUseCase().execute("Division", query);
      this.setState({ division, selectedDivision: "" });
    }
    this.presenter.onChange();
  };

  handleDivisionChange = async (selectedDivision) => {
    this.setState({ selectedDivision });
    this.presenter.onChange();
    if (selectedDivision === "") {
      this.setState({ section: [], selectedSection: "" });
    }
    if (selectedDivision) {
      const query = {
        where: {
          status: "active",
          division: selectedDivision.id,
        },
      };
      const section = await findObjectUseCase().execute("Sections", query);
      this.setState({ section, selectedSection: "" });
    }
  };

  getStateRegion() {
    return this.state.selectedRegion.id;
  }

  getStateOffice() {
    return this.state.selectedOffice.id;
  }

  getStateDivision() {
    return this.state.selectedDivision.id;
  }

  getStateSection() {
    return this.state.selectedSection.id;
  }

  handleSectionChange = (selectedSection) => {
    this.setState({ selectedSection });
    this.presenter.onChange();
  };

  onChange(value, field) {
    this.setState({ [field]: value });
  }

  render() {
    const object = this.state.object;
    const { region, office, division, section } = this.state;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div className="p-0">
                          <label>
                            Name <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="name"
                            object={object}
                            placeholder="name"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            Description <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="description"
                            object={object}
                            placeholder="description"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            OCOM <span className="text-danger">*</span>
                          </label>
                          <SearchSelect
                            focus={true}
                            value={this.state.selectedRegion?.name}
                            onChange={this.handleRegionChange}
                            onClickClear={() => this.handleRegionChange("")}
                            disabled={region.length < 1}
                            options={region.map((officeItem) => ({
                              label: officeItem.name,
                              value: {
                                name: officeItem.name,
                                id: officeItem.id,
                              },
                            }))}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            Location <span className="text-danger">*</span>
                          </label>

                          <SearchSelect
                            focus={true}
                            value={this.state.selectedOffice?.name}
                            onChange={this.handleOfficeChange}
                            onClickClear={() => this.handleOfficeChange("")}
                            disabled={office.length < 1}
                            options={office.map((officeItem) => ({
                              label: officeItem.name,
                              value: {
                                name: officeItem.name,
                                id: officeItem.id,
                              },
                            }))}
                            placeholder="Select Location"
                          />
                        </div>

                        {/* DIvision  */}
                        <div className="p-0">
                          <label>
                            Region <span className="text-danger">*</span>
                          </label>

                          <SearchSelect
                            focus={true}
                            value={this.state.selectedDivision?.name}
                            onChange={this.handleDivisionChange}
                            onClickClear={() => this.handleDivisionChange("")}
                            disabled={division.length < 1}
                            options={division.map((divisionItem) => ({
                              label: divisionItem.name,
                              value: {
                                name: divisionItem.name,
                                id: divisionItem.id,
                              },
                            }))}
                            placeholder="Select Region"
                          />
                        </div>

                        {/* Section */}
                        <div className="p-0">
                          <label>
                            Subport/ IPEE/ Main RIOU{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <SearchSelect
                            focus={true}
                            value={this.state.selectedSection?.name}
                            onChange={this.handleSectionChange}
                            onClickClear={() => this.handleSectionChange("")}
                            disabled={section.length < 1}
                            options={section.map((sectionItem) => ({
                              label: sectionItem.name,
                              value: {
                                name: sectionItem.name,
                                id: sectionItem.id,
                              },
                            }))}
                            placeholder="Select Subport/ IPEE/ Main RIOU"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(UnitFormPage);
